/** "Loading Operations…" from `/hospitality/operations/...` (second segment). */
export const DEFAULT_LOADER_MESSAGE = 'Loading…';

const SEGMENT_LOADER_LABELS: Record<string, string> = {
  rooms: 'Room setup',
  customers: 'Guests',
  'walk-ins': 'Walk-ins',
  recipients: 'Recipients',
};

export const getRouteLoadingMessage = (pathname: string) => {
  const parts = pathname.split('/').filter(Boolean);
  const segment = parts[1] || parts[0];
  if (!segment) return DEFAULT_LOADER_MESSAGE;
  const mapped = SEGMENT_LOADER_LABELS[segment];
  if (mapped) return `Loading ${mapped}…`;
  try {
    const decoded = decodeURIComponent(segment);
    const titled = decoded.charAt(0).toUpperCase() + decoded.slice(1);
    return `Loading ${titled}…`;
  } catch {
    const titled = segment.charAt(0).toUpperCase() + segment.slice(1);
    return `Loading ${titled}…`;
  }
};
